var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LOGIN_ACTION_TYPE } from '../actions/login.actions';
var initialState = {};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case LOGIN_ACTION_TYPE.GET_AUTH:
            return __assign(__assign({}, state), { authData: action.payload });
        default:
            return state;
    }
};
export default reducer;
